import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import { faArrowLeft, faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { MenuDropdownToggle } from "../MenuDropdownToggle";

interface HeadPageProps {
  headText: string;
  onToggle?: (isOpen: boolean) => void;
  onBack?: () => void;
  children?: React.ReactNode;
}

export function HeadPageComponent(props: HeadPageProps) {
  const navigate = useNavigate();

  const handleCliNavigateBack = () => () => {
    if (props.onBack) {
      props.onBack();
      return;
    }
    navigate(-1);
  };

  return (
    <Row>
      <Col xs={2} sm={1} md={1} lg={1}>
        <Button variant="link" onClick={handleCliNavigateBack()}>
          <FontAwesomeIcon size="lg" icon={faArrowLeft} />
        </Button>
      </Col>
      <Col
        xs={8}
        sm={10}
        md={10}
        lg={10}
        className="d-flex align-content-center flex-wrap justify-content-center"
      >
        <div className="head-text">{props.headText}</div>
      </Col>
      <Col
        xs={2}
        sm={1}
        md={1}
        lg={1}
        className="d-flex align-content-center flex-wrap justify-content-end"
      >
        {props.children !== undefined && (
          <Dropdown
            onToggle={(isOpen) => props.onToggle && props.onToggle(isOpen)}
          >
            <MenuDropdownToggle>
              <FontAwesomeIcon icon={faEllipsisV} />
            </MenuDropdownToggle>
            <Dropdown.Menu align="end">{props.children}</Dropdown.Menu>
          </Dropdown>
        )}
      </Col>
    </Row>
  );
}
